import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const ControlClose = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
    strokeAsPrimary: true,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 26 10'
    >
      <path
        fill={primaryColorToUse}
        d='M2.601 9.085.567 7.051A1.92 1.92 0 0 1 .69 4.217 19 19 0 0 1 8.622.447a18.7 18.7 0 0 1 8.135 0 19 19 0 0 1 7.96 3.798 1.92 1.92 0 0 1 .129 2.827l-2.034 2.034a1.92 1.92 0 0 1-2.522.19 12.3 12.3 0 0 0-2.38-1.43 1.92 1.92 0 0 1-1.126-1.737V4.407a15.34 15.34 0 0 0-8.135 0V6.13a1.92 1.92 0 0 1-1.126 1.736 12.3 12.3 0 0 0-2.38 1.43 1.92 1.92 0 0 1-2.542-.21'
      />
    </svg>
  );
};
